const STORAGE_KEY = 'app_completed_tours';

function getCompletedTours(): Record<string, boolean> {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? (JSON.parse(raw) as Record<string, boolean>) : {};
  } catch {
    return {};
  }
}

export function markTourCompleted(tourName: string): void {
  const tours = getCompletedTours();
  tours[tourName] = true;
  localStorage.setItem(STORAGE_KEY, JSON.stringify(tours));
}

export function isTourCompleted(tourName: string): boolean {
  return !!getCompletedTours()[tourName];
}

export function resetTour(tourName: string): void {
  const tours = getCompletedTours();
  delete tours[tourName];
  localStorage.setItem(STORAGE_KEY, JSON.stringify(tours));
}

export function resetAllTours(): void {
  localStorage.removeItem(STORAGE_KEY);
}
